export default "__VITE_ASSET__BRlIFjXT__ 120w, __VITE_ASSET__D9Xsggp4__ 240w, __VITE_ASSET__CL9YMXqo__ 480w, __VITE_ASSET__B7htByyO__ 512w";